export function initLazyLoad() {
    const images = document.querySelectorAll('img.lazy');

    images.forEach(img => {
        const originalSrc = img.getAttribute('src');
        if (originalSrc) {
            img.setAttribute('data-src', originalSrc);
            img.removeAttribute('src');
        }
        img.classList.add('lazy');

        const container = img.parentElement;
        if (container && container.classList.contains('lazy-container')) {
            container.classList.remove('loaded');
        }
    });

    function loadImages() {
        const images = document.querySelectorAll('img.lazy:not([src])');
        images.forEach(img => {
            const rect = img.getBoundingClientRect();
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;

            if (rect.top >= -windowHeight && rect.top <= windowHeight * 2) {
                const dataSrc = img.getAttribute('data-src');
                if (dataSrc) {
                    const imgObj = new Image();
                    imgObj.src = dataSrc;
                    imgObj.onload = () => {
                        img.src = dataSrc;
                        img.classList.add('loaded');
                        img.classList.remove('lazy');

                        const container = img.parentElement;
                        if (container && container.classList.contains('lazy-container')) {
                            container.classList.add('loaded');
                        }
                    };
                }
            }
        });
    }

    loadImages();

    let ticking = false;
    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                loadImages();
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });

    window.addEventListener('resize', loadImages);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyLoad);
} else {
    initLazyLoad();
}
